import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import CloseIcon from '@material-ui/icons/Close';

import SlideTransition from '../_Shared/Transitions/SlideTransition';
import DataLoadEditor from './QueryEditors/DataLoadEditor';
import DataJoinEditor from './QueryEditors/DataJoinEditor';
import DefaultQueryEditor from './QueryEditors/DefaultQueryEditor';

const _ = require('lodash');
const uuidv4 = require('uuid/v4');
const styles = {
    appBar: {
        position: 'relative'
    },
    flex: {
        flex: 1
    }
};

class PackageQueryEditor extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            query: props.query
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { query } = this.props;
        if (query !== null && !_.isEqual(prevProps.query, query)) {
            this.setState({ query });
        }
    }

    saveQuery = () => {
        const { onSaveQuery, onClose } = this.props;
        const { query } = this.state;

        onSaveQuery(query);
        onClose();
    }

    editSettings = (name, value) => {
        const { query } = this.state;
        this.setState({ query: Object.assign({}, query, { settings: { ...query.settings, [name]: value } }) });
    }

    editColumn = (column, index) => {  
        const { query } = this.state;

        let columns = Object.assign([], query.columns);
        columns.splice(index, 1, column);
        
        this.setState({ query: Object.assign({}, query, { columns }) });
    }

    add = () => {
        const { query } = this.state;

        let orders = Object.assign([], query.columns.map(x => x.order));
        let maxOrder = orders.length > 0 ? Math.max(...orders) + 1 : 0;
        let column = { id: uuidv4().replace(/-/g, ''), order: maxOrder, name: '', alias: '', type: '', dataType: '', defaultValue: '' };
        let updQuery = Object.assign({}, query, { columns: [...query.columns, column] });

        this.setState({ query: updQuery });
    }

    getEditor = () => {
        const { parentQueries } = this.props;
        const { query } = this.state;
        if (query === null) return '';
        switch (query.icon) {
            case 'dataload': return <DataLoadEditor query={query} onEditColumn={this.editColumn} onEditSettings={this.editSettings} onAdd={this.add} />
            case 'datajoin': return <DataJoinEditor query={query} parentQueries={parentQueries} />
            default: return <DefaultQueryEditor query={query} />
        }
    }
    
    render() {
        const { classes, open, onClose } = this.props;
        return (<Dialog fullScreen open={open} onClose={onClose} TransitionComponent={SlideTransition}>
                    <AppBar className={classes.appBar}>
                        <Toolbar>
                            <IconButton color="inherit" onClick={onClose} aria-label="Close"><CloseIcon /></IconButton>
                            <Typography variant="title" color="inherit" className={classes.flex}>{this.props.title}</Typography>
                            <Button color="inherit" onClick={this.saveQuery}>Save</Button>
                        </Toolbar>
                    </AppBar>
                    {
                        this.getEditor()
                    }
                </Dialog>);
    }
}

PackageQueryEditor.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PackageQueryEditor);


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/PackageQueryEditor.js